import React, { useEffect, useRef, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/dashboard.css";
import { getLocalStorageUserData } from "../../utils/userData";
// Functional component for the Home page
const AdminDashboard = () => {
  const naviagte = useNavigate();
  const userData = getLocalStorageUserData();
  return (
    <>
      <div className="container-fluid page_background">
        <div className="page-inner-content dashboardSectionBox">
          <div className="page_inner_content_box fund_holding_section">
            <div className="d-flex justify-content-between align-itmes-center mb-4">
              <h5 className="page-title">Investors</h5>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
